export default "__VITE_ASSET__DXB9iwP2__"